import { anim, prog, stagger } from '../../../motion'
import { Shape } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'

const HIDDEN_SHAPES = [
  ['tri', 'yellow'],
  ['sq', 'green'],
  ['dot', 'pink'],
  ['tri', 'blue'],
  ['sq', 'yellow']
]

// Eisberg: Über Wasser liegt der Lebenslauf, die Kamera taucht ab zu dem, was er nicht zeigt
export default function DemoProblem() {
  const c = useCopy('problem')

  return (
    <div className='cin-full dm-ice'>
      <div
        className='dm-ice__world'
        style={{
          ...prog([0.26, 0.46]),
          transform: 'translateY(calc(var(--p) * -58cqh))'
        }}
      >
        <div className='dm-ice__head'>
          <Line at={[0, 0.06]} className='cin-eyebrow'>
            {c.eyebrow}
          </Line>
          <h2 className='cin-title'>
            <Words text={c.title} at={[0.02, 0.14]} />
          </h2>
          <Line at={[0.12, 0.2]} y={20} className='cin-title cin-muted'>
            {c.sub}
          </Line>
        </div>

        <div className='dm-ice__tip' />
        <div className='dm-cv' style={anim({ at: [0.04, 0.12], y: 60 })}>
          <div className='dm-cv__photo' />
          <div className='dm-cv__title'>{c.cv}</div>
          <i style={{ width: '82%' }} />
          <i style={{ width: '64%' }} />
          <i style={{ width: '74%' }} />
          <i style={{ width: '52%' }} />
        </div>
        <div
          className='dm-ice__visible'
          style={anim({ at: [0.14, 0.2], x: 40, y: 0 })}
        >
          <div className='dm-ice__label'>{c.visible}</div>
          {c.visibleItems.map((v) => (
            <div key={v} className='dm-ice__item'>
              {v}
            </div>
          ))}
        </div>

        <div className='dm-ice__sea'>
          <svg
            className='dm-ice__berg'
            viewBox='0 0 600 520'
            preserveAspectRatio='none'
            aria-hidden='true'
          >
            <path d='M250 0 L350 0 L470 70 L560 210 L540 360 L420 490 L260 516 L120 450 L46 300 L80 150 Z' />
          </svg>
          <div className='dm-ice__hidden'>
            <Line
              at={[0.36, 0.42]}
              y={20}
              className='dm-ice__label dm-ice__label--light'
            >
              {c.hidden}
            </Line>
            {c.hiddenItems.map((h, i) => (
              <div
                key={h}
                className='dm-ice__gem'
                style={anim({
                  at: stagger(0.4, 0.035, 0.08, i),
                  y: 40,
                  s: 0.7
                })}
              >
                <Shape
                  kind={HIDDEN_SHAPES[i][0]}
                  color={HIDDEN_SHAPES[i][1]}
                  size={22}
                />
                {h}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='dm-problems'>
        {c.problems.map((p, i) => (
          <article
            key={p.title}
            className='dm-problem'
            style={anim({ at: stagger(0.66, 0.05, 0.1, i), y: 80 })}
          >
            <span className='dm-problem__num'>0{i + 1}</span>
            <h3 className='dm-problem__title'>{p.title}</h3>
            <p className='dm-problem__text'>{p.text}</p>
          </article>
        ))}
      </div>
    </div>
  )
}
